import React, { useState } from "react";
import FlareIcon from "@material-ui/icons/Flare";
import AndroidIcon from "@material-ui/icons/Android";
import DescriptionIcon from "@material-ui/icons/Description";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import MicIcon from "@material-ui/icons/Mic";
import BarChartIcon from "@material-ui/icons/BarChart";
import TrackChangesIcon from "@material-ui/icons/TrackChanges";
import { SUHAVI_MODULES } from "../homeV2.constants";
import HvButton from "./HvButton";
import Reveal from "./Reveal";

const SUHAVI_MODULE_ICONS: Record<string, React.ComponentType<{ fontSize?: "inherit" | "default" | "small" | "large" }>> = {
  ask: AndroidIcon,
  resume: DescriptionIcon,
  autoApply: FlashOnIcon,
  voice: MicIcon,
  tracker: BarChartIcon,
  match: TrackChangesIcon,
};

const Suhavi = () => {
  const [showAll, setShowAll] = useState(false);

  return (
    <section className="hv2-suhavi" id="suhavi">
      <div className="home-v2__container">
        <Reveal as="div" className="hv2-suhavi__header">
          <span className="hv2-suhavi__badge">
            <FlareIcon fontSize="inherit" /> The Engine Behind employHER
          </span>
          <h2 className="home-v2__h2">
            Meet <span className="home-v2__highlight">Suhavi AI</span>
          </h2>
          <p className="hv2-suhavi__sub">
            Your complete Career Operating System. Suhavi handles the administrative burden of job
            hunting—from ATS-compliant resume tailoring to automated applications and AI-voice mock
            interviews—so you can focus on landing the role.
          </p>
          <HvButton variant="primary" href="#">
            Unlock Your Career OS →
          </HvButton>
        </Reveal>

        <Reveal delay={0.08} className={`hv2-suhavi__modules ${showAll ? "hv2-suhavi__modules--all" : ""}`}>
          {SUHAVI_MODULES.map((module) => {
            const ModuleIcon = SUHAVI_MODULE_ICONS[module.icon];
            return (
            <div className="hv2-module-card" key={module.title}>
              <div className="hv2-module-card__icon">
                <ModuleIcon fontSize="inherit" />
              </div>
              <h3>{module.title}</h3>
              <p>{module.description}</p>
              <div className="hv2-module-card__tags">
                {module.tags.map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </div>
            </div>
            );
          })}
        </Reveal>

        <div className="hv2-suhavi__more">
          <button type="button" className="hv2-btn hv2-btn--outline" onClick={() => setShowAll((current) => !current)}>
            {showAll ? "Show fewer modules ←" : "See all modules →"}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Suhavi;
